import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { LessonsFacade } from '../facades/lessons.facade';

export function lessonsCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const lessonsFacade = inject(LessonsFacade);
        lessonsFacade.clear();

        return true;
    };
}
